import React, { useState } from "react";


class Pi {//Path item
    constructor(text, event, children, opts) {
        this.text = text;
        this.event = event;
        if (children != null) {
            this.children = [...children];
        }
        this.optionsList = [];
        if (opts != null) {
            this.addOpts(opts);
        }
    }

    equals(other) {
        let comp = this.text === other.text && this.event === other.event;
        return comp;
    }

    static event(text, children, opts) {
        return new Pi(text, true, children, opts);
    }

    static action(text, children, opts) {
        return new Pi(text, false, children, opts);
    }

    addOpts(optsToAdd) {
        this.optionsList = this.optionsList.concat(optsToAdd);
        return this;
    }

    getOpts() {
        return this.optionsList;
    }

    possiblePaths() {
        return Pi.possiblePaths([], this, []);
    }

    useCpy(children) {
        return new Pi(this.text, this.event, [].concat(children), this.opts);
    }

    static possiblePaths(path, current, result) {
        path.push(current);
        if (current.children == null) {
            result.push(Question.fromPathTree(path));
            return result;
        } else {
            for (var i = 0; i < current.children.length; i++) {
                Pi.possiblePaths([...path], current.children[i], result);
            }
            return result;
        }
    }
}

class Question {
    constructor(path, options) {
        this.path = path;
        this.options = options;
    }

    static qAct(path, option) {
        return new Question(path, option);
    }

    static oneQ(question, answer, options) {
        let ans = Pi.action(answer);
        return new Question([Pi.event(question), ans], options.map(o => Pi.action(o)).concat(ans));
    }

    static order(question, order, extraOps) {
        let orderOpt = order.map(i => Pi.action(i));
        if (extraOps == null) {
            extraOps = [];
        }
        return new Question([Pi.event(question)].concat(orderOpt), orderOpt.concat(extraOps.map(i => Pi.action(i))));
    }

    static qManyA(question, answers, options) {
        let ans = answers.map(a => Pi.action(a));
        return new Question([Pi.event(question), ans], options.map(o => Pi.action(o)).concat(ans));
    }

    static fromPathTree(path) {
        let optionsFromPath = [];
        path.forEach(pt => pt.getOpts().forEach(o => optionsFromPath.push(o)));
        path.filter(pt => !pt.event).forEach(pt => optionsFromPath.push(pt));
        optionsFromPath = onlyUnique2(optionsFromPath);

        return Question.qAct(path, optionsFromPath);
    }
}



const Questionary = ({ questions }) => {
    let [qs, setQs] = useState([...shuffleArray(questions)]);

    let [wrongs, setWrongs] = useState(0);

    return (<div>
        <progress value={questions.length - qs.length}
            max={questions.length} style={{ marginBottom: '10px', width: '100%', height: '40px' }} />
        {qs.length == 0 ?
            <>
                <p>Bra jobbat! Du har gjort färdigt quizet</p>
                <p>Du hade totalt {wrongs} felaktiga gissningar!</p>
                <button className="nextButton btn btn-primary "
                    onClick={e => setQs(shuffleArray(questions))}
                >Kör igen</button>
            </>
            :
            <OneQuestion question={qs[0]} key={qs[0].text + wrongs}
                correctCallback={i => {
                    if (i == 0) {
                        setQs(qs.slice(1));
                    } else {
                        setQs([...qs.slice(1), qs[0]]);
                    }
                    setWrongs(wrongs + i);
                }}
            />
        }
    </div>);
}

const OneQuestion = ({ question, correctCallback }) => {
    let [progress, setProgress] = useState(0);
    let [wrongs, setWrongs] = useState(0);

    let [correctAnswers, setCorrectAnswers] = useState(0);

    let options = "";
    if (question.path.length > progress + 1) {

        let used = question.path.slice(0, progress + 1);
        let opts = question.options.filter(p => !used.some(pt => pt.equals(p)));
        opts = opts.concat(question.path.slice(progress + 1).flat().filter(pi => !pi.event));

        let correct = [].concat(question.path[progress + 1]).map(q => q.text);

        options = (<>
            <span key={"optionsArrow"} className="arrow">↓</span>
            {shuffleArray(onlyUnique2(opts)).map(t =>
                <OneOption key={t.text}
                    isCorrect={
                        correct.includes(t.text)
                    }
                    correctCallback={() => {
                        setCorrectAnswers(correctAnswers + 1);
                        if (correctAnswers + 1 == correct.length) {
                            setProgress(progress + 1);
                            setCorrectAnswers(0);
                        }
                    }}
                    wrongCallback={() => setWrongs(wrongs + 1)}
                >{t.text}</OneOption>)}</>);
    }

    if (question.path.length == progress + 1) {
        options = (<button key={"nextButton"} className="nextButton btn btn-primary "
            onClick={e => {
                setProgress(0);
                correctCallback(wrongs);
                setWrongs(0);
            }}
            style={{ marginTop: '10px' }}
        >Next</button>);
    }

    return (<>
        {question.path.slice(0, progress + 1).map((pi, i) =>
            <div key={"answer" + i} >
                {[].concat(pi).map(onePi => (<div key={onePi.text} className={(!pi.event && i != 0) ? "right guess" : ""}><span>{onePi.text}</span></div>))}
                {(i <= progress - 1) ? (<span key={pi.text + "arrow"} className="arrow">↓</span>) : null}
            </div>
        )}
        {options}
    </>);
};

const OneOption = ({ children, isCorrect, correctCallback, wrongCallback }) => {
    let [guessed, setGuessed] = useState(false);
    let [correct, setCorrect] = useState(false);
    return (<div className={"guess " + (guessed ? "wrong" : "") + (correct ? " right" : "") + (!correct && !guessed ? " unguessed" : "")}
        onClick={e => {
            if (isCorrect) {
                setCorrect(true);
                correctCallback();
            } else {
                setGuessed(true);
                wrongCallback();
            }
        }}
    >{children}</div>);
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

function onlyUnique2(array) {
    let map = new Map();

    array.forEach(pi => map.set(pi.text, pi));

    return Array.from(map.values());
}

export { Pi, Question, Questionary };